import { isSSR } from "../Utils/ssr-utils.js";
const shouldShowDebuggingInfo = (isDebugMode = false) => {
  if (isSSR()) {
    return false;
  }
  return /ricos-debug/i.test(window.location.search) || isDebugMode;
};
export {
  shouldShowDebuggingInfo
};
//# sourceMappingURL=should-show-debugging-info.js.map
